import DettaglioPianoCard from "common/components/dettaglio-piano-card";
import RiepilogoTitolariCard from "common/components/riepilogo-titolari";
import Header from "layout/components/header";
import Sidebar from "layout/components/sidebar";
import Topbar from "layout/components/topbar";
import { Col, Row } from "react-bootstrap";
import { Outlet } from "react-router-dom";

const ThirdStepPage: React.FC = () => {
	return (
		<>
			<Sidebar />
			<div className="wrapper d-flex flex-column min-vh-100">
				<div className="body flex-grow-1 px-0">
					<Header />
					<Topbar />
					<div className="container-fluid body-section px-0">
						<section>
							<Row>
								<Col sm={12} lg={8}>
									<Outlet />
								</Col>

								<Col sm={12} md={4} className="side-card">
									<DettaglioPianoCard />
									<RiepilogoTitolariCard />
								</Col>
							</Row>
						</section>
					</div>
				</div>
			</div>
		</>
	);
};
export default ThirdStepPage;
